import React, { useEffect, useState } from "react";
import HesteskoSVG from "./HesteskoSVG";
import CircleSVG from "./CircleSVG";

export default function IframeWrapper() {
  const [type, setType] = useState(null);

  useEffect(() => {
    // Get query parameters from the URL
    const queryParams = new URLSearchParams(window.location.search);

    // Access individual parameters
    setType(queryParams.get("type"));

    // Use the parameters in your app logic

    // Add your conditional rendering logic here based on the parameters
  }, []);

  if (type === "hestesko") {
    return (
      <div
        style={{
          //   backgroundColor: "#fff",
          //   minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <HesteskoSVG />
      </div>
    );
  }

  if (type === "circle") {
    return (
      <div
        style={{
          //   backgroundColor: "#fff",
          //   minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <CircleSVG />
      </div>
    );
  }

  return <div className="App">not able to load</div>;
}
